import React, {useEffect, useState} from 'react';
import { Box,   } from '@mui/material';
import PageContent from './partials/PageContent'
import PageHeader from './partials/PageHeader'
import { getPageSolutionTrainData } from "../../../services/pages";
import Preloader from '../../common/Preloader'; 
//import image from '../../../assets/images/soluciones_trains_data.png';
import AOS from 'aos';

const PageTrainsSolutions = () => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
    const [pageData, setPagesData] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const [pageResponse,] = await Promise.all([ getPageSolutionTrainData(),  ]);          
          setPagesData(pageResponse || {});
        } catch (error) {
          console.error("Error fetching data:", error.response || error.message);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);
  
    if (loading) { return <Preloader />; }
  
    const { title, description, content, image } = pageData.page_train;

  return (
  <Box className="solution-page" id="page-air">
    <PageHeader 
      title={title}
      prev="End to end Asistencia al viajero" 
      hrefPrev="/solutions/assist" 
      next="End to End Circuitos"      
      hrefNext="/solutions/tour-circuits" 
    />
    <PageContent 
      content={content} 
      title={title} 
      description={description} 
      image={image}
    /> 
   {/*  <Box className="solution-page-content">
      <Container maxWidth="lg">
        <Grid data-aos="fade-up" container spacing={1}>
          <Grid size={{ xs: 12, md: 6 }}>
            <PageContent content={ 
              <>
                <div className="destacado">
                  <p>
                  Nuestro módulo de trenes ofrece una solución integral para la venta y gestión de viajes en tren. 
                  Diseñado para facilitar la experiencia tanto de los usuarios como de los administradores, 
                  la plataforma incluye herramientas avanzadas de búsqueda, resultados configurables, integración 
                  de múltiples proveedores ferroviarios y opciones de pago seguras. A continuación, se detallan las 
                  principales características y funcionalidades de la plataforma:
                  </p>
                </div>
                                
                  <h3><span className="icon icon-search"></span> Buscador</h3>

                  <p>
                  El buscador permite a los usuarios adquirir tickets y pases, brindando acceso a los principales proveedores de servicios ferroviarios. Diseñado para ofrecer una experiencia flexible e intuitiva, el buscador incluye diversas opciones de personalización:
                  </p>

                  <ul>
                    <li>
                      <strong>Criterios de búsqueda:</strong>
                      <ul>
                        <li>Búsqueda por ciudades de origen y destino.</li>
                        <li>Selección de estaciones específicas.</li>
                        <li>Fechas de ida y vuelta, con la posibilidad de elegir solo ida.</li>
                      </ul>
                    </li>
                  </ul>

                  <h3><span className="icon icon-search-results"></span> Resultados de Búsqueda</h3>

                  <p>
                  El listado de resultados proporciona información detallada y opciones de personalización: Por precio, tiempo de viaje, horarios y recomendación.
                  </p>

                  <ul>
                    <li>
                      <strong>Información mostrada:</strong>
                      <ul>
                        <li>Nombre y categoría del tren.</li>
                        <li>Proveedor ferroviario.</li>
                        <li>Servicios a bordo (Wi-Fi, aire acondicionado, comidas, espacios para bicicletas, etc.).</li>
                        <li>Políticas de cancelación y cambios.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Filtros avanzados:</strong>
                      <ul>
                        <li>Trenes directos</li>
                        <li>Cambio de horario</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Tarifas:</strong>
                      <ul>
                        <li>Mejor precio</li>
                        <li>Semi Flexible</li>
                        <li>Flexible</li>
                      </ul>
                    </li>
                  </ul>

                  <h3><span className="icon icon-dollar"></span> Proceso de Checkout</h3>

                  <p>El proceso de compra en GoTrenes.com está diseñado para ser seguro, rápido y flexible:</p>
                  <ul>
                    <li>
                      <strong>Opciones de pago:</strong>
                      <ul>
                        <li>Posee distintos procesadores que resuelven la instancia del cobro.</li>
                        <li>Soporte para pagos a crédito en el modelo B2B.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Confirmación de compra:</strong>
                      <ul>
                        <li>Recepción inmediata del boleto electrónico con los detalles de la reserva.</li>
                      </ul>
                    </li>
                  </ul>

                  <p>Desde el panel de configuración, las agencias pueden personalizar la operativa de la plataforma:</p>
                  <ul>
                    <li><strong>Contenido:</strong> Control total para priorizar o promover determinados proveedores en rutas específicas.</li>
                    <li><strong>Markup y comisiones:</strong> Reglas dinámicas para añadir márgenes según rutas, temporadas o clases de boleto.</li>
                    <li><strong>Políticas de cancelación:</strong> Adaptables según las condiciones de los proveedores ferroviarios.</li>
                    <li><strong>Automatización de procesos:</strong> Configuración de liquidaciones y facturación.</li>
                  </ul>




                  <h3><span className="icon icon-integrations"></span>  Integración con Proveedores Ferroviarios</h3>

                  <p>
                  Más de 50 proveedores ferroviarios integrados: accede al contenido aprovechando tus propios acuerdos comerciales. Además, nuestra capa de normalización de datos permite incorporar fácilmente nuevos proveedores para adaptarse a tus necesidades específicas.
                  </p>
                  <ul>
                    <li>Proveedores destacados: Deutsche Bahn (DB), Trenitalia, Eurostar, Renfe, SNCF (incluyendo TGV y Intercités), 
                      Italo, NS International (Holanda), SNCB/NMBS (Bélgica), SBB (Suiza, para algunos servicios internacionales), 
                      ÖBB (Austria, principalmente trenes internacionales, Ouigo y otros.</li>
                  </ul>              





              </>
            } />   

            <Button data-aos="fade-up" startIcon={<ArrowForwardIcon />}  variant="contained" color="primary" component={Link} to="/contact" >
                Solicita una Demostración
            </Button>     
          
          </Grid>
        </Grid>
        <Box data-aos="fade-left" data-aos-delay="300" className='absolute-image' component="img" src={image} alt="End to end Aéreos" />
      </Container>
    </Box> */}
  </Box>)
}

export default PageTrainsSolutions;


